import {Component, OnDestroy, OnInit} from '@angular/core';
import {Form, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {NotificationsService, ProjectService} from "@catcore/services";
import {Subscription} from "rxjs";
import {isNullOrUndefined} from "util";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {EntitySchemaType} from "@catcore/utils/json-schema/entity-schema-to-json-schema";

@Component({
  selector: 'catapp-new-ggw-dynamic-route-template',
  templateUrl: './new-ggw-dynamic-route-template.component.html',
  styleUrls: ['./new-ggw-dynamic-route-template.component.scss']
})
export class NewGgwDynamicRouteTemplateComponent implements OnInit, OnDestroy {

  private projectSubscription: Subscription;
  private resourceService;

  project;

  form: FormGroup;

  constructor(formBuilder: FormBuilder,
              private projectService: ProjectService,
              entityService: EntitySchemaService,
              resourceService: GenericResourceService,
              private notificationService: NotificationsService) {
    this.form = formBuilder.group({
      name: new FormControl('', [Validators.required])
    });

    let schema = entityService.getForEntityName(EntitySchemaType['ProjectGgwDynamicRouteTemplates']);
    this.resourceService = resourceService.findServiceForResource(schema.resourceUri);
  }

  ngOnInit() {
    this.projectService.getCurrentProject()
      .subscribe((project) => {
        this.project = project;
      });
  }

  ngOnDestroy() {
    if (this.projectSubscription) {
      this.projectSubscription.unsubscribe();
    }
  }

  onSubmit($event) {
    this.resourceService.save({
      name: this.form.value.name,
      project: this.project._links.self.href
    }, true).subscribe((result) => {
      this.notificationService.success('Creation successful', 'Successfully added a new ggw dynamic route template to the project.');
      this.projectService.refreshCurrent();
      this.form.reset();
    })
  }

  formIsReady() {
    return this.form && !isNullOrUndefined(this.project) && !isNullOrUndefined(this.project.id);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/components/new-ggw-dynamic-route-template/new-ggw-dynamic-route-template.component.ts